module.exports = __webpack_public_path__ + "static/10-42e4f5f4358fed3ca9ee29ece5239bfe.jpg";